import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Stack,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import ContractOSImage from "./images/contractos1.png";
import HeroImage from "./images/stamps.png";

const ContractOSDescription = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      <Container maxW="container.xl" py={8}>
        <Stack spacing={8} align="stretch">
          {/* Header Section */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={12}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
          >
            <Image
              src={ContractOSImage}
              alt="ContractOS"
              maxW="400px"
              mx="auto"
              mb={6}
            />
          </Box>

          {/* Main Content */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800">
              Event Driven Processing
            </Heading>

            <Text fontSize="lg" mb={6} lineHeight="1.8" color="gray.700">
              Enable intelligent contract operations that respond dynamically to business events and automate routine processes.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={8}>
              <Box>
                <Heading size="lg" color="cyan.600" mb={4}>
                  Key Capabilities
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="cyan.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Intelligent contract behavior
                    </Text>
                  </Box>

                  <Box p={4} bg="cyan.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Tailored automation
                    </Text>
                  </Box>

                  <Box p={4} bg="cyan.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Event-responsive processing
                    </Text>
                  </Box>

                  <Box p={4} bg="cyan.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Distributed settlement
                    </Text>
                  </Box>
                </Stack>
              </Box>

              <Box>
                <Heading size="lg" color="cyan.600" mb={4}>
                  Description
                </Heading>
                <Box p={4} bg="cyan.50" borderRadius="md">
                  <Text color="gray.700" fontSize="md" lineHeight="1.8">
                    ContractOS transforms traditional contract management into an intelligent system that responds to business events, reduces manual effort, and ensures consistent operations across your portfolio.
                  </Text>
                </Box>
              </Box>
            </SimpleGrid>

            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="cyan"
                size="lg"
                onClick={() => navigate("/contractos")}
                boxShadow="lg"
                _hover={{ transform: "scale(1.05)" }}
                transition="all 0.2s"
              >
                Explore ContractOS
              </Button>
            </Box>
          </Box>

        </Stack>
      </Container>
    </Box>
  );
};

export default ContractOSDescription;
